import { render, staticRenderFns } from "./featureDrawer.vue?vue&type=template&id=31825fcf&scoped=true&"
import script from "./featureDrawer.vue?vue&type=script&lang=js&"
export * from "./featureDrawer.vue?vue&type=script&lang=js&"
import style0 from "./featureDrawer.vue?vue&type=style&index=0&id=31825fcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31825fcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31825fcf')) {
      api.createRecord('31825fcf', component.options)
    } else {
      api.reload('31825fcf', component.options)
    }
    module.hot.accept("./featureDrawer.vue?vue&type=template&id=31825fcf&scoped=true&", function () {
      api.rerender('31825fcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/roadmap/featureDrawer.vue"
export default component.exports